import { Component, AfterViewInit, OnDestroy, ComponentRef, ViewChild, Type, ChangeDetectorRef, ComponentFactoryResolver } from '@angular/core';
import { Subject } from 'rxjs';
import { DialogRef } from './dialog-ref';
import { DialogChildInsertionDirective } from './dialog-directive';
import { ModalComponent } from '../modal/modal.component';
import { SelectionMode } from '../grid/grid.model';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html'
})
export class DialogComponent implements AfterViewInit, OnDestroy {
  componentRef: ComponentRef<any>;

  @ViewChild(DialogChildInsertionDirective) insertionPoint: DialogChildInsertionDirective;
  @ViewChild(ModalComponent) modal: ModalComponent;

  public title: string;
  public maxwidth: string;
  public selectionMode: SelectionMode = SelectionMode.none;
  private get selectionModes() { return SelectionMode; }

  private readonly _onClose = new Subject<any>();
  public onClose = this._onClose.asObservable();

  childComponentType: Type<any>;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private cd: ChangeDetectorRef,
    private dialogRef: DialogRef
  ) {}

  ngAfterViewInit() {
    this.setConfiguredValues();

    if(this.maxwidth) {
        this.modal.openWithCustomSize({maxwidth: this.maxwidth});
    } else {
        this.modal.open();
    }

    this.loadChildComponent(this.childComponentType);
    this.cd.detectChanges();
  }

  loadChildComponent(componentType: Type<any>) {
    let componentFactory = this.componentFactoryResolver.resolveComponentFactory(componentType);

    let viewContainerRef = this.insertionPoint.viewContainerRef;
    viewContainerRef.clear();

    this.componentRef = viewContainerRef.createComponent(componentFactory);

    if(this.dialogRef.dialogConfig.data) {
        this.componentRef.instance.dialogConfigData = this.dialogRef.dialogConfig.data;
    }

    if(this.selectionMode == SelectionMode.single) {
      this.componentRef.instance.onItemSelected.subscribe((item) => { this.close(item)});
    }

    if(this.selectionMode == SelectionMode.none) {
      this.componentRef.instance.onDialogClose.subscribe((data) => { this.close(data)});
    } else {
      this.componentRef.instance.selectionMode = this.selectionMode;
    }

    this.componentRef.instance.isOnDialog = true;
  }

  ngOnDestroy() {
    if (this.componentRef) {
      this.componentRef.destroy();
    }
  }

  close(result?: any) {
    this.dialogRef.close(result);
    this.modal.close();
  }

  returnSelectedItems() {
    let selectedItems = this.componentRef.instance.grid.getSelectedItems();
    this.close(selectedItems);
  }

  setConfiguredValues() {
    this.selectionMode = this.dialogRef.dialogConfig.selectionMode;
    this.title = this.dialogRef.dialogConfig.title;
    this.maxwidth = this.dialogRef.dialogConfig.maxwidth;
  }

  confirmDialog() {
    this.componentRef.instance.confirmDialog();
  }

  closeDialog() {
    this.componentRef.instance.closeDialog();
  }
}
